export default __webpack_public_path__ + "static/media/test_result_wrong.7e79656a.svg";